<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Alojamiento Bases de Datos</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Alojamiento Bases de Datos</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Principales Usos</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-vault"></i>
                            <h3>Tecnología Financiera y Banca</h3>
                            <p>Gestión de transacciones en tiempo real con PostgreSQL y SQL Server.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-cart-shopping"></i>
                            <h3>Comercio Electrónico</h3>
                            <p>Gestión de hardware médico y almacenamiento de datos sensibles.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-building"></i>
                            <h3>Empresas SaaS</h3>
                            <p>Almacenamiento de datos de usuarios con MongoDB o PostgreSQL.
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>





<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">¿Qué es el Alojamiento de Bases de Datos?</h2>

                    <p class="text-justify">
                        es un servicio que permite a empresas y desarrolladores almacenar, gestionar y acceder a sus
                        bases de datos en una infraestructura segura y escalable en la nube. En lugar de depender de
                        servidores locales, los datos se alojan en nuestros centros de datos optimizados, garantizando
                        alto rendimiento, disponibilidad y seguridad.
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>


<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">Rendimiento y Seguridad para tus Datos</h2>
                    <p class="text-justify">
                        En enCloud, ofrecemos un servicio especializado de Alojamiento de Bases de Datos que garantiza
                        alta disponibilidad, rendimiento optimizado y seguridad avanzada para tus aplicaciones.

                        Ya sea que manejes bases de datos transaccionales críticas, almacenamiento masivo de información
                        o análisis de datos, nuestros servidores están diseñados para soportar cargas de trabajo
                        exigentes con escalabilidad a la medida de tu negocio.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">Características Clave</h2>


                </div>

                <ul class="custom-list">
                    <li><strong>Rendimiento Óptimo</strong> – Infraestructura con discos NVMe, RAM de alto rendimiento y
                        CPU dedicadas para consultas rápidas.</li>
                    <li><strong>Seguridad Avanzada</strong> – Cifrado en tránsito y en reposo, con firewalls dedicados y
                        monitoreo 24/7.</li>
                    <li><strong>Backups Automatizados</strong> – Copias de seguridad programadas y opciones de
                        recuperación en caso de fallos.</li>
                    <li><strong>Escalabilidad Flexible</strong> – Aumenta el almacenamiento, la RAM y los procesadores
                        según crezca tu base de datos.</li>
                    <li><strong>Compatibilidad </strong> - Con múltiples motores de bases de datos desde MySQL hasta
                        bases de datos NoSQL avanzadas.</li>
                </ul>
            </div>


        </div>
    </div>
</section>

<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Tipos de Alojamiento de Bases de Datos </h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-1"></i>
                            <h3>Bases de Datos Relacionales (SQL)</h3>
                            <div class="row">
                                <a>🔹 MySQL</a>
                                <a>🔹 PostgreSQL
                                </a>
                                <a>🔹 MariaDB
                                </a>
                                <a>🔹MS SQL Server
                                </a>
                                <a>🔹Oracle
                                </a>
                            </div>
                            <p class="example"><strong>Ejemplo de uso:</strong> Aplicaciones empresariales, ERPs,
                                e-commerce, transacciones bancarias.</p>
                        </li>
                        <li>
                            <i class="fa-solid fa-2"></i>
                            <h3>Bases de Datos NoSQL</h3>
                            <div class="row">
                                <a>🔹 MongoDB</a>
                                <a>🔹 Cassandra
                                </a>
                                <a>🔹 CouchDB
                                </a>
                                <a>🔹 DynamoDB
                                </a>
                            </div>
                            <p class="example"><strong>Ejemplo de uso:</strong> Big Data, aplicaciones en tiempo real,
                                IoT, gestión de contenido.</p>

                        </li>

                        <li>
                            <i class="fa-solid fa-3"></i>
                            <h3>Bases de Datos en Memoria </h3>
                            <div class="row">
                                <a>🔹 Redis</a>
                                <a>🔹 Memcached</a>
                            </div>
                            <p class="example"><strong>Ejemplo de uso:</strong> Caché de alto rendimiento, aceleración
                                de aplicaciones web y móviles.</p>

                        </li>

                        <li>
                            <i class="fa-solid fa-4"></i>
                            <h3>Análisis de Datos y Data Warehousing</h3>
                            <div class="row">
                                <a>🔹 ClickHouse</a>
                                <a>🔹 Redshift</a>
                                <a>🔹 Snowflake</a>
                            </div>
                            <p class="example"><strong>Ejemplo de uso:</strong> Análisis de grandes volúmenes de datos,
                                inteligencia de negocios, reportes avanzados.</p>

                        </li>
                        <li>
                            <i class="fa-solid fa-5"></i>
                            <h3>Alta Disponibilidad y Clustering</h3>
                            <div class="row">
                                <a>🔹 Galera Cluster (MySQL)</a>
                                <a>🔹 Patroni (PostgreSQL)</a>
                                <a>🔹 MongoDB ReplicaSet</a>
                            </div>
                            <p class="example"><strong>Ejemplo de uso:</strong> Aplicaciones críticas que requieren cero
                                tiempo de inactividad y balanceo de carga.</p>

                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>

<section class="domain-pricing-list-area pt-70">
    <div class="container">
        <div class="row">


            <div class="col-lg-12 col-md-12">
                <h2 class="custom-table-title">Seguridad y Protección de Datos</h2>
                <div class="custom-table">

                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Nivel de Seguridad </th>
                                <th scope="col">Descripción</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Cifrado en Tránsito y en Reposo
                                </td>

                                <td class="special">
                                    Protección de los datos mediante protocolos TLS y cifrado AES-256.

                                </td>

                            </tr>
                            <tr>
                                <td scope="row">
                                    Firewalls y Control de Acceso
                                </td>

                                <td class="special">
                                    Configuración de listas de acceso, IP whitelisting y VPNs privadas.

                                </td>

                            </tr>
                            <tr>
                                <td scope="row">
                                    Backups Automáticos y Personalizados
                                </td>

                                <td class="special">
                                    Opciones de snapshots diarios, semanales y en tiempo real.
                                </td>

                            </tr>
                            <tr>
                                <td scope="row">
                                    Monitoreo y Alertas en Tiempo Real </td>

                                <td class="special">
                                    Seguimiento de métricas clave, detección de ataques y fallos de hardware.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</section>



<section class="pricing-area pt-100">
    <div class="container">
        <div class="section-title">
            <h2>📦 Planes de Alojamiento de Bases de Datos
            </h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>DB Inicial</h3>
                        <p>Para pequeñas empresas y startups</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>CPU: (1 vCPU)</li>
                            <li><i class="flaticon-tick"></i> RAM: (4GB)</li>
                            <li><i class="flaticon-tick"></i> Disco: (50GB HDD)</li>
                            <li><i class="flaticon-tick"></i> Bases de Datos Compatibles: <br>🔹 MySQL <br>🔹 PostgreSQL
                                <br>🔹 MongoDB <br>🔹 Redis <br>🔹 SQL Server
                            </li>
                            <li><i class="flaticon-tick"></i> Respaldos: Automáticos </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>DB Empresarial</h3>
                        <p>Para negocios en expansión</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> CPU: (4 vCPUs)</li>
                            <li><i class="flaticon-tick"></i> RAM: (8GB)</li>
                            <li><i class="flaticon-tick"></i> Disco: (200GB SDD)</li>
                            <li><i class="flaticon-tick"></i> Bases de Datos Compatibles: <br>🔹 MySQL <br>🔹 PostgreSQL
                                <br>🔹 MongoDB <br>🔹 Redis <br>🔹 SQL Server
                            </li>
                            <li><i class="flaticon-tick"></i> Respaldos: Automáticos </li>


                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>DB Personalizado</h3>
                        <p>Para necesidades específicas</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> CPU: (6+ vCPUs)</li>
                            <li><i class="flaticon-tick"></i> RAM: (8GB+)</li>
                            <li><i class="flaticon-tick"></i> Disco: (200GB+ SDD)</li>
                            <li><i class="flaticon-tick"></i> Bases de Datos Compatibles: Tenemos un amplio catálogo de
                                base de datos disponibles</li>
                            <li><i class="flaticon-tick"></i> Respaldos: Automáticos </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>